import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { useDispatch } from 'react-redux';
import { updateDict } from './store/dictSlice';
import { getDict } from './query/api';
import { message } from 'antd';
import { useMemoizedFn } from 'ahooks';

function App() {
  const dispatch = useDispatch();

  const fetchDictData = useMemoizedFn(() => {
    // 应用启动时获取字典数据
    getDict().then((res) => {
      if (!res.data.success) {
        return Promise.reject({
          message: res?.data?.msg,
        });
      }
      
      const newDict = res.data.data;
      
      // 更新 sessionStorage
      sessionStorage.setItem('dict', JSON.stringify(newDict));
      console.log('字典数据已更新到 sessionStorage');
      
      dispatch(updateDict(newDict));
    }).catch((error) => {
        console.error('获取字典数据失败:', error);
        // 初始化默认字典数据到 sessionStorage
        const defaultDict = {
          robotType: [],
          sceneType: [],
          sceneStatus: [],
          robotSpecs: {},
          robotSpecsSimple: {},
          peripherals: []
        };
        sessionStorage.setItem('dict', JSON.stringify(defaultDict));
        dispatch(updateDict(defaultDict));
      })
  });

  useEffect(() => {
    fetchDictData();
  }, [dispatch]);

  return (
    <div>
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
